import axios from 'axios'
import Qs from 'qs'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

export default {
  // localStorage缓存
  localstorage: {
    //判断是否支持localstorage
    support: function () {
      return !!window.localStorage;
    },
    //设置本地存储
    set: function (key, value) {
      if (this.support) {
        if (typeof value !== 'string') {
          if (typeof value === 'object') {
            value = JSON.stringify(value);
          }
        }
        window.localStorage.setItem(key, value);
      }
    },
    //获取
    get: function (key) {
      if (this.support) {
        return window.ses = localStorage.getItem(key);
      }
    },
    //清除
    clear: function () {
      if (this.support) {
        window.localStorage.clear();
      }
    },
    // 单个清除
    removeItem: function (key) {
      if (this.support) {
        window.localStorage.removeItem(key);
      }
    }
  },
  // sessionStorage缓存
  sessionstorage: {
    //判断是否支持sessionStorage
    support: function () {
      return !!window.sessionStorage;
    },
    //设置本地存储
    set: function (key, value) {
      if (this.support) {
        if (typeof value !== 'string') {
          if (typeof value === 'object') {
            value = JSON.stringify(value);
          }
        }
        window.sessionStorage.setItem(key, value);
      }
    },
    //获取
    get: function (key) {
      if (this.support) {
        return window.ses = sessionStorage.getItem(key);
      }
    },
    //清除
    clear: function () {
      if (this.support) {
        window.sessionStorage.clear();
      }
    },
    // 单个清除
    removeItem: function (key) {
      if (this.support) {
        window.sessionStorage.removeItem(key);
      }
    }
  },
  // cookie
  cookie: {
    /*
     * 设置cookie
     * 参数 name 名称
     * val 值
     * parm 对象{
     G：过期时间毫秒(以当前时间开始计算)
     domin：域名
     path :表示cookie所在的目录
     }
     */
    set: function (name, val, parm) {
      var d;
      parm.G && (d = new Date, d.setTime(d.getTime() + parm.G));
      document.cookie = name + '=' + val + (d ? '; expires=' + d.toGMTString() : '') + '; domain=' + (parm.domin ? parm.domin : '') + '; path=' + (parm.path ? parm.path : '') + ';';
    },

    // *	获取cookie
    // * 	参数name cookie名

    get: function (name) {
      return (name = RegExp('(^| )' + name + '=([^;]*)(;|$)').exec(document.cookie)) ? name[2] : null;
    },
    /*
     * 删除cookie
     * 参数name cookie名
     */
    del: function (name) {
      var cookieVal = utils.cookie.get(name);
      if (cookieVal) {
        utils.cookie.set(name, cookieVal, {
          'G': -1
        });
      } else {
        throw '您要删除的cookie' + name + '没有找到！';
      }
    },
    // 设置cookie定时器，10分钟
    setCookieTime: function () {
      this.set('logout', new Date().getTime(), {
        'G': 30 * 60 * 1000
      });
    }
  },
}

export function httpGet (url,data = {}, retryTimes = 0) {//增加失败自动重新请求功能，默认不自动请求，需要手动添加retryTimes来限制重试次数
  return axios.get(url, {params: data}).then((res) => {
    return Promise.resolve(res.data)
  }).catch((res) => {
    if(retryTimes > 0){
      retryTimes--;
      return httpGet(url,data, retryTimes)
    }
    return Promise.reject(res)
    
  })
}
export function httpPost (url,data, retryTimes = 0) {//增加失败自动重新请求功能，默认不自动请求，需要手动添加retryTimes来限制重试次数
  return axios.post(url,Qs.stringify(data))
    .then((res) => {
      return Promise.resolve(res.data)
    }).catch((res) => {
      if(retryTimes > 0){
        console.log('请求出错重试', res)
        retryTimes--;
        return httpPost(url,data, retryTimes)
      }
      return Promise.reject(res)
      
    })
}
//json格式发送数据
export function httpPostJson (url,data, retryTimes = 0) {
  return axios.post(url,data,{
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch((res) => {
    if (retryTimes > 0) {
      console.log('请求出错重试', res)
      retryTimes--;
      return httpPostJson(url, data, retryTimes)
    } 
    return Promise.reject(res)
    
  })
}

// 将word文档读取成arraybuffer
export function httpGetArraybuffer(url){
  return new Promise((resolve,reject)=>{
    const xhr = new XMLHttpRequest()
    xhr.open('get', url, true)
    xhr.responseType = 'arraybuffer'
    xhr.send()
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.response)
      }
    }
    xhr.onerror = (error) => {
      reject(error)
    }
  })
}





// WEBPACK FOOTER //
// ./src/common/js/util.js